var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTz = function SvgTz(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -283.77)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uA729"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.4621 290.54q0.6379 0 1.4216 0.34021 0.60145 0.26124 1.1178 0.91736 0.4921 0.63183 0.4921 1.4702 0 1.3426-0.92344 2.0777-0.92344 0.73511-2.6245 0.73511-0.57107 0-1.1725-0.10936-0.60753-0.11543-1.2515-0.34021v-1.1847q0.51032 0.29768 1.1178 0.44956 0.60753 0.15189 1.2697 0.15189 1.1543 0 1.7557-0.45565 0.60753-0.45564 0.60753-1.3244 0-0.80194-0.55892-1.2576-0.55285-0.44957-1.5674-0.44957h-1.0571v-1.0085l2.6124-3.0316h-4.0218v3.6694q0 0.83231 0.22478 1.0692 0.23086 0.23694 0.92951 0.23694h1.1482v0.93559h-1.1482q-1.294 0-1.7861-0.47995-0.4921-0.48602-0.4921-1.7618v-3.6938h-0.82016v-0.86876h0.82016v-1.9319h1.1239v1.9319h5.2794v1.0206z",
    strokeWidth: 0.31105,
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTz, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tz.a662d2e8.svg";
export { ForwardRef as ReactComponent };